import cookieUtils from '../utils/cookieUtils';
// Responds to UPDATE_TRIP action
const updateTrip = (_, action) => {
    if (typeof window === 'undefined') {
        return;
    }
    cookieUtils.writeCookiesFromTripData(action && action.payload || {});
};

export {updateTrip};



// WEBPACK FOOTER //
// ./src/universal/middleware/trip.js